var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScrollIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 34,
    viewBox: "0 0 23 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 11110"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.5 0C5.1588 0 0 4.39531 0 9.79803V23.5123C0 28.915 5.1588 33.3103 11.5 33.3103C17.8412 33.3103 23 28.915 23 23.5123V9.79803C23 4.39531 17.8412 0 11.5 0ZM20.6543 23.5123C20.6543 27.8128 16.5475 31.3118 11.5 31.3118C6.45246 31.3118 2.3457 27.8128 2.3457 23.5123V9.79803C2.3457 5.49751 6.45246 1.99854 11.5 1.99854C16.5475 1.99854 20.6543 5.49751 20.6543 9.79803V23.5123Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.5001 7.93115C10.843 7.93115 10.3105 8.46881 10.3105 9.13232V14.661C10.3105 15.3242 10.843 15.8622 11.5001 15.8622C12.157 15.8622 12.6898 15.3242 12.6898 14.661V9.13232C12.6898 8.46881 12.1573 7.93115 11.5001 7.93115Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollIcon);
export default __webpack_public_path__ + "static/media/scroll-icon.f60e8504405e08f4ba65d0168afaf7e8.svg";
export { ForwardRef as ReactComponent };